import "./_modale.scss";

import cx from "classnames";
import {useCallback, useEffect} from "react";

const modaleVariant = (variant: string): object => {
  return {
    "modale-green": variant.includes("validate"),
    "modale-red": variant.includes("negate"),
  };
};

// close doit contenir une fonction permettant de faire passer isOpen à false.
export function Modale({
  title,
  children,
  isOpen,
  close,
  variant = "primary",
}: {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  close: () => void;
  variant?: "validate" | "primary" | "negate";
}): JSX.Element {
  const closeModal = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
      event.preventDefault();
      const isInModal =
        (event.target as HTMLElement).className === "modale" ||
        (event.target as HTMLElement).tagName === "SPAN";
      if (isInModal) {
        close();
      }
    },
    [close],
  );
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event instanceof KeyboardEvent && event.key === "Escape") {
        event.preventDefault();
        // 27 correspond à la touche "Escape"
        close();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, closeModal]);
  return (
    <div className={cx("modale", isOpen ? "" : " hidden")} onClick={closeModal}>
      <div className={cx("modale-bloc", modaleVariant(variant))}>
        <div className="modale-bloc--header">
          <h4>{title}</h4> <span onClick={closeModal}>&times;</span>
        </div>
        <div className="modale-bloc--content">{children}</div>
      </div>
    </div>
  );
}
